import React from "react"
import {FieldFormElementViewProps} from "../../../../render/form-elemnent-view"
import FieldTimeDuration_EditableInlineInput from "./inline-editable/input-editable-inline"

export default function FieldTimeDuration_FormElementView(props:FieldFormElementViewProps) {

    const disabled  = _.get(props.options, 'disabled', false) || _.get(props, 'disabled', false)
    const value     = props.field.getViewValue(props.model)

    return <FieldTimeDuration_EditableInlineInput viewClasses  = {Classes("ui5-txt-default ui5-field-form-editable h-36 p-l-10 p-r-10", props.className)}
                                                  editClasses  = {Classes("ui5-txt-default ui5-field-form-editable h-36 p-l-10 p-r-10", props.className)}
                                                  field        = {props.field}
                                                  value        = {value}
                                                  disabled     = {disabled}
                                                  options      = {props.options}
                                                  onEnter      = {props.onEnter}
                                                  onChange     = {props.onChange}/>
}
